import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {	
	FETCH_VAT_PARTNERS: createAsyncActionConstants('FETCH_VAT_PARTNERS'),
    FETCH_VAT_PARTNER_EDIT_REASONS: createAsyncActionConstants('FETCH_VAT_PARTNER_EDIT_REASONS'),
	SET_VAT_PARTNERS_TABLE_DATA: 'SET_VAT_PARTNERS_DATA',
	SET_VAT_PARTNERS_TABLE_ROW: 'SET_VAT_PARTNERS_TABLE_ROW',
	SET_VAT_PARTNERS_TABLE_ROWS: 'SET_VAT_PARTNERS_TABLE_ROWS',
	CLEAR_VAT_PARTNERS_TABLE_DATA: 'CLEAR_VAT_PARTNERS_TABLE_DATA',
	UPDATE_VAT_PARTNER_ISSO: createAsyncActionConstants('UPDATE_VAT_PARTNER_ISSO'),
	UPDATE_VAT_PARTNER_ESSO: createAsyncActionConstants('UPDATE_VAT_PARTNER_ESSO'),
	FETCH_VAT_PARTNER_VALUE: createAsyncActionConstants('FETCH_VAT_PARTNER_VALUE'),
}
